import { Button } from "@/components/ui/button";
import { SLOT_STATUS_TEXT } from "@/hooks/useSlotPicker";

// R15 U1 - the one renderer for availability. It says WHY there is nothing to pick (loading / a real empty day / not permitted / could not load) and offers a retry only when a retry can help.
// `idPrefix` keeps each surface's existing test ids (book-slot-1215PM, call-book-no-slots, ...).
export function SlotPickerView({ picker, idPrefix = "book", gridClass = "grid grid-cols-3 sm:grid-cols-4 gap-1.5", compact = false, testIdFor = null, labelFor = null, buttonClass = "" }) {
  const { status, slots, slot, select, reload, error } = picker;
  const text = compact ? "text-xs" : "text-sm";
  if (status === "idle") return null;
  if (status === "loading") return <p data-testid={`${idPrefix}-slots-loading`} className={`${text} text-muted-foreground`}>{SLOT_STATUS_TEXT.loading}</p>;
  if (status === "empty") return <p data-testid={`${idPrefix}-no-slots`} className={`${text} text-muted-foreground`}>{SLOT_STATUS_TEXT.empty}</p>;
  if (status === "forbidden") return <p data-testid={`${idPrefix}-slots-forbidden`} role="alert" className={`${text} text-[hsl(var(--danger))]`}>{SLOT_STATUS_TEXT.forbidden}</p>;
  if (status === "error") {
    return (
      <div data-testid={`${idPrefix}-slots-error`} role="alert" className={`${text} space-y-1`}>
        <p className="text-[hsl(var(--danger))]">{SLOT_STATUS_TEXT.error}{error ? ` (${typeof error === "string" ? error : "error"})` : ""}</p>
        <Button data-testid={`${idPrefix}-slots-retry`} size="sm" variant="outline" onClick={reload}>Try again</Button>
      </div>
    );
  }
  return (
    <div className={gridClass} data-testid={`${idPrefix}-slots-grid`}>
      {slots.map((s) => (
        <Button key={s.start} data-testid={testIdFor ? testIdFor(s) : `${idPrefix}-slot-${s.label.replace(/[: ]/g, "")}`} size="sm" className={buttonClass}
          variant={slot === s.start ? "default" : "outline"} aria-pressed={slot === s.start} onClick={() => select(s.start)}>
          {labelFor ? labelFor(s) : s.label}
        </Button>
      ))}
    </div>
  );
}
